module.exports = __webpack_public_path__ + "img/file-img-other.9dda8df6.jpg";